import React, { Component, DOM, PropTypes, PureComponent } from 'react';
import { Alert, Button, Spinner } from 'react-fast-ui';
import FormControl from '../../components/inputs/FormControl';
import ForgotPasswordLink from '../../components/ForgotPasswordLink';
import PageTitle from '../../PageTitle';

class LoginForm extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    value: PropTypes.shape({
      username: PropTypes.string,
      password: PropTypes.string
    }),
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  focus = field => {
    return this.refs[ field ] ? this.refs[ field ].focus() : null;
  };

  focusUsername = () => this.focus('username');
  focusPassword = () => this.focus('password');

  render() {
    const { loading, value, onChange, onSubmit } = this.props;

    const changed = more => onChange({ ...value, ...more });
    const handleSubmit = e => {
      e.preventDefault();
      onSubmit();
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="mg-bottom-sm">
          <label>E-mail</label>
          <FormControl>
            <input
              type="text" disabled={loading} placeholder="E-mail" required="true"
              value={value && value.username ? value.username : ''}
              ref="username" onChange={(e) => changed({ username: e.target.value })}
            />
          </FormControl>
        </div>

        <div className="mg-bottom-md">
          <label>Password</label>
          <FormControl>
            <input
              type="password" disabled={loading} placeholder="Password" required="true"
              value={value && value.password ? value.password : ''}
              ref="password" onChange={(e) => changed({ password: e.target.value })}
            />
          </FormControl>
        </div>

        <Button
          text="Login" type="success" className="full-width" icon="sign-in"
          loading={loading} submit={true}
          disabled={loading}
          loadingIcon={<Spinner className="mg-right-sm"/>}
        />
        <ForgotPasswordLink className="mg-top-md center-block"/>
      </form>
    );
  }
}

export default class LoginPage extends Component {
  static contextTypes = {
    dao: PropTypes.object.isRequired,
    onTokenChange: PropTypes.func.isRequired
  };

  state = {
    credentials: {},
    request: null,
    error: null
  };

  componentDidMount() {
    this.refs.form.focusUsername();
  }

  login = () => {
    const { dao } = this.context;
    const { request } = this.state;

    // we're already trying to log in
    if (request) {
      return;
    }

    const { credentials } = this.state;

    this.setState({
      request: dao.login(credentials)
        .then((token) => {
          const { onTokenChange } = this.context;
          onTokenChange(token);
        }, (error) => {
          this.setState({ request: null, error }, () => this.refs.form.focusPassword());
        })
    });
  };

  renderError() {
    const { error, request } = this.state;

    if (!request && !!error) {
      return <Alert level="danger" strong="Error!" message={error.message}/>;
    }

    return null;
  }

  handleCredentialChange = credentials => this.setState({ credentials });

  render() {
    const { request, credentials } = this.state;

    return (
      <PageTitle title="Log In">
        <div className="display-flex flex-direction-column align-items-center mg-top-lg">
          <div style={{ maxWidth: 330, width: '100%', padding: 8 }}>
            <LoginForm
              ref="form" loading={!!request} onChange={this.handleCredentialChange} value={credentials}
              onSubmit={this.login}
            />

            <div className="align-self-baseline mg-top-sm">
              { this.renderError() }
            </div>
          </div>
        </div>
      </PageTitle>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/LoginPage.jsx